import { LineChart, LineChartProps } from '../../../../renderers/line-chart/line-chart.component';
import { NIVALIZ_TRANSACTION_VOLUME_LINE_CHART_DEFINITION } from './nivaliz-transaction-volume-line-chart.definition';
import { NIVALIZ_TRANSACTION_VOLUME_LINE_CHART_MOCK_DATA } from './nivaliz-transaction-volume-line-chart.mock';

export const NivalizTransactionVolumeLineChart = (props: LineChartProps) => (
    <LineChart
        {...props}
        showArea
    />
);

NivalizTransactionVolumeLineChart.definition = NIVALIZ_TRANSACTION_VOLUME_LINE_CHART_DEFINITION;
NivalizTransactionVolumeLineChart.mockData = NIVALIZ_TRANSACTION_VOLUME_LINE_CHART_MOCK_DATA;
